module.exports = __webpack_public_path__ + "img/icon_exchange.80c894a5.svg";